import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import useAuth from '@/hooks/useAuth';
import { getMinutesInMilliseconds, getSecondsInMilliseconds } from '@/utils/getMilliseconds';

const parsedTimeoutMinutes = Number(process.env.REACT_APP_TIMEOUT_IN_MINUTES);
const TIMEOUT_MINUTES = getMinutesInMilliseconds(
  Number.isNaN(parsedTimeoutMinutes) ? 5 : parsedTimeoutMinutes
);

// How long the idle warning modal is shown before the user is actually logged out.
const parsedPromptBeforeIdleSeconds = Number(process.env.REACT_APP_PROMPT_BEFORE_IDLE_SECONDS);
const PROMPT_BEFORE_IDLE_SECONDS = getSecondsInMilliseconds(
  Number.isNaN(parsedPromptBeforeIdleSeconds) ? 30 : parsedPromptBeforeIdleSeconds
);

export const useUserActivity = () => {
  const { onLogout, setIsForceLogout, setIsLoggedIn } = useAuth()!;
  const [showIdleModal, setShowIdleModal] = useState(false);

  const onIdle = () => {
    setShowIdleModal(false);
    setIsForceLogout(true);
    setIsLoggedIn(false);
    onLogout();
  };

  const onPrompt = () => {
    setShowIdleModal(true);
  };

  const onActive = () => {
    setShowIdleModal(false);
  };

  const { activate, getRemainingTime } = useIdleTimer({
    onIdle,
    onPrompt,
    onActive,
    timeout: TIMEOUT_MINUTES,
    promptBeforeIdle: PROMPT_BEFORE_IDLE_SECONDS
  });

  return { showIdleModal, stayActive: activate, getRemainingTime };
};
